import { getLocalStorageItem } from "./Localstorage/localStorageUtils";

export function boardLocal() {
    const data = getLocalStorageItem('board');

    try {
        return data;
    } catch (e) {
        console.error('Error parsing JSON from localStorage (board):', e);
        return null;
    }
}

export function columnsLocal() {
    const data = getLocalStorageItem('columns');
 
    try {
        return data;
    } catch (e) {
        console.error('Error parsing JSON from localStorage (columns):', e);
        return null;
    }
}

export function tasksLocal() {
    const data = getLocalStorageItem('tasks')
  
    try {
        return data;
    } catch (e) {
        console.error('Error parsing JSON from localStorage (tasks):', e);
        return null;
    }
}

export function userDataLocal() {
    const data = getLocalStorageItem('userData')
 
    try {
        return data;
    } catch (e) {
        console.error('Error parsing JSON from localStorage (userData):', e);
        return null;
    }
}
